import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'contextMenuColor',
})
export class ContextMenuColorPipe implements PipeTransform {
  transform(color: string, reverse: boolean, isBackground = false) {
    return (!reverse && !isBackground) || (reverse && isBackground) ? color : this.secondaryColor(color);
  }

  private readonly secondaryColor = (color: string) =>
    color?.toUpperCase().substr(0, 4) === '#FFF' || color === 'transparent' || color === 'none' ? '#03053D' : '#FFFFFF';
}
